if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

            connectedCallback() {
        this.mgSlideHandler = (event) =>
          this.mgPrepareNextImage(event.detail?.currentElement, true);

        this.elements.viewer?.addEventListener(
          'slideChanged', this.mgSlideHandler
        );

        this.mgPrepareNextImage(
          this.elements.viewer?.querySelector('.product__media-item.is-active') ||
          this.elements.viewer?.querySelector('.product__media-item')
        );
      }

      disconnectedCallback() {
        this.elements.viewer?.removeEventListener(
          'slideChanged', this.mgSlideHandler
        );
        this.mgNextController?.abort();
        clearTimeout(this.mgNextTimer);
      }

      mgPrepareNextImage(slide, immediate = false) {
        this.mgNextController?.abort();
        clearTimeout(this.mgNextTimer);

        if (!slide || this.mql.matches || navigator.connection?.saveData) return;

        const selector = '.product__modal-opener--image .product__media img';
        const current = slide.querySelector(selector);
        if (!current) return;

        const controller = this.mgNextController = new AbortController();
        const options = { once: true, signal: controller.signal };

        const allowed = () => !controller.signal.aborted &&
          this.isConnected && !this.mql.matches && !document.hidden;

        const start = () => {
          if (!allowed()) return;

          if (!immediate && document.readyState !== 'complete') {
            window.addEventListener('load', start, options);
            return;
          }

          if (!immediate && !current.complete) {
            current.addEventListener('load', start, options);
            return;
          }

          if (!immediate && !current.naturalWidth) return;

          const warmNext = () => {
            if (!allowed()) return;

            let next = slide.nextElementSibling;

            while (next && !next.clientWidth) {
              next = next.nextElementSibling;
            }

            const image = next?.querySelector(selector);

            if (!image || (image.complete && image.naturalWidth)) return;

            image.setAttribute('fetchpriority', 'low');
            image.setAttribute('loading', 'eager');
          };

          if (immediate) warmNext();
          else this.mgNextTimer = setTimeout(warmNext, 150);
        };

        if (!current.complete) {
          current.setAttribute('fetchpriority', 'high');
          current.setAttribute('loading', 'eager');
        }

        start();
      }

      onSlideChanged(event) {
        if (!this.elements.thumbnails) return;

        const currentElement =
          event.detail && event.detail.currentElement;

        if (!currentElement || !currentElement.dataset) return;

        const mediaId = currentElement.dataset.mediaId;

        if (!mediaId) return;

        const thumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );

        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');

        if (!activeMedia) return;

        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {
            element.classList.remove('is-active');
          });

        activeMedia.classList.add('is-active');

        if (prepend) {
          const mediaParent = activeMedia.parentElement;

          if (
            mediaParent &&
            mediaParent.firstChild !== activeMedia
          ) {
            mediaParent.prepend(activeMedia);
          }

          if (this.elements.thumbnails) {
            const thumbnailToPrepend =
              this.elements.thumbnails.querySelector(
                `[data-target="${mediaId}"]`
              );

            if (
              thumbnailToPrepend &&
              thumbnailToPrepend.parentElement &&
              thumbnailToPrepend.parentElement.firstChild !== thumbnailToPrepend
            ) {
              thumbnailToPrepend.parentElement.prepend(thumbnailToPrepend);
            }
          }

          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }
        }

        this.mgPrepareNextImage(activeMedia, true);
        this.preventStickyHeader();

        window.setTimeout(() => {
          const mediaParent = activeMedia.parentElement;

          if (
            mediaParent &&
            (!this.mql.matches || this.elements.thumbnails)
          ) {
            mediaParent.scrollTo({
              left: activeMedia.offsetLeft
            });
          }

          const activeMediaRect =
            activeMedia.getBoundingClientRect();

          if (activeMediaRect.top > -0.5) return;

          const top =
            activeMediaRect.top + window.scrollY;

          window.scrollTo({
            top: top,
            behavior: 'smooth'
          });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );

        if (!activeThumbnail) return;

        this.setActiveThumbnail(activeThumbnail);

        const mediaPosition =
          activeThumbnail.dataset.mediaPosition;

        if (mediaPosition) {
          this.announceLiveRegion(
            activeMedia,
            mediaPosition
          );
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
